import { render, staticRenderFns } from "./VoiceCode.vue?vue&type=template&id=66594df0&"
import script from "./VoiceCode.vue?vue&type=script&lang=ts&"
export * from "./VoiceCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports